import { useMemo } from 'react'
import './styles.less'

/**
 * 推荐问题组件
 *
 * 这是聊天系统中用于显示推荐问题的组件，支持问题列表展示、点击交互、展开收起等功能。
 * 帮助用户快速开始对话，提供常见问题的快捷入口。
 *
 * 功能特点：
 * - 支持推荐问题列表展示
 * - 支持问题点击交互
 * - 支持展开/收起功能
 * - 支持鼠标悬停效果
 * - 支持会话状态控制
 * - 响应式布局设计
 */

/**
 * 推荐问题列表组件
 *
 * @param list - 推荐问题列表
 * @param onClick - 问题点击回调函数
 * @param conversation - 会话内容
 * @param recohandleMouseEnter - 鼠标进入回调函数
 * @param recohandelMouseLeave - 鼠标离开回调函数
 */
function RecommendComponent({ list, onClick, conversation = '', recohandleMouseEnter, recohandelMouseLeave }) {
  return (
    <div
      onMouseEnter={recohandleMouseEnter}
      onMouseLeave={recohandelMouseLeave}
      className={
        'item chatComponent_recommendedContTag group relative h-full w-[100%]'
        // conversation
        //   ? 'item chatComponent_recommendedContTag group relative h-full w-[100%]'
        //   : 'item group relative h-full w-[100%]'
      }
      style={{
        background: '#F5F6F8',
        padding: '16px 20px 20px',
        boxSizing: 'border-box',
        borderRadius: '8px'
        // boxShadow:
        //   '0px -8px 10px -5px rgba(0, 0, 0, 0.03),-8px 0px 10px -5px rgba(0, 0, 0, 0.03), 8px 0px 10px -5px rgba(0, 0, 0, 0.03)'
      }}
    >
      {/* 推荐问题标题 */}
      <span
        className="flexRowStart"
        style={{
          marginBottom: '16px',
          fontSize: '16px',
          color: '#000000',
          fontWeight: '600'
        }}
      >
        <span>推荐问题</span>
      </span>

      {/* 推荐问题列表 */}
      <div className="chatComponent_recommendedCont_caseY  flexRowStart flexWrap">
        {list.map((chat, i) => (
          <div
            className="flexRowStart flexWrap"
            onClick={e => {
              onClick(chat)
            }}
            key={i}
            style={{ maxWidth: '100%' }}
          >
            <p
              className={
                // conversation
                //   ? 'cursonCase chatComponent_recommendedCont chatComponent_recommendedCont_caseY_conver domOverflowEllip'
                //   : 'cursonCase chatComponent_recommendedCont chatComponent_recommendedContTag domOverflowEllip'
                'cursonCase chatComponent_recommendedCont chatComponent_recommendedCont_caseY_conver domOverflowEllip'
              }
              style={{ color: '#7587A5', width: '100%' }}
            >
              {chat}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

/*
 *
 * @param locked - 是否锁定状态，锁定时不显示推荐问题
 * @param recommendedHid - 推荐问题是否隐藏
 * @param chatsRef - 聊天容器的引用
 * @param list - 推荐问题列表
 * @param handleSelectChat - 处理问题选择的回调函数
 * @param chatId - 聊天ID
 * @param recomConversation - 推荐会话内容
 * @param regenerate - 重新生成推荐问题的回调函数
 * @param onClick - 问题点击回调函数
 * @param conversation - 会话内容
 * @param recohandleMouseEnter - 鼠标进入回调函数
 * @param recohandelMouseLeave - 鼠标离开回调函数
 * @param mouseHid - 鼠标隐藏状态
 */
export default function RecommendedCont({
  locked,
  recommendedHid,
  chatsRef,
  list,
  handleSelectChat,
  chatId,
  recomConversation,
  regenerate,
  onClick,
  conversation = '',
  recohandleMouseEnter,
  recohandelMouseLeave,
  mouseHid
}) {
  // 处理推荐问题列表，当前直接返回原列表
  const words = useMemo(() => {
    return list
  }, [list])

  // 如果锁定状态或没有推荐问题，则不显示
  if (locked || !words.length) return null

  // 发送后的状态：显示推荐问题组件
  if (words.length > 0) {
    return (
      <div style={{ position: 'relative', bottom: '8px' }}>
        {/* 展开/收起控制按钮 */}
        {(mouseHid || (!mouseHid && !recommendedHid)) && words.length > 0 && (
          <div
            onMouseEnter={recohandleMouseEnter}
            onMouseLeave={recohandelMouseLeave}
            className="chantComponent_offCloseIcon cursonCase"
            onClick={regenerate}
          >
            {recommendedHid ? (
              // 收起状态：向下箭头
              <svg width="44" height="16" viewBox="0 0 44 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="16" rx="8" fill={'#FFFFFF'} />
                <path
                  d="M18 6L22 10L26 6"
                  stroke="#B5BFDA"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              // 展开状态：向上箭头
              <svg width="44" height="16" viewBox="0 0 44 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="16" rx="8" fill={'#FFFFFF'} />
                <path
                  d="M18 10L22 6L26 10"
                  stroke="#B5BFDA"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
        )}

        {/* 推荐问题列表组件 */}
        {recommendedHid && (
          <RecommendComponent
            recohandleMouseEnter={recohandleMouseEnter}
            recohandelMouseLeave={recohandelMouseLeave}
            conversation={conversation}
            onClick={onClick}
            list={words}
          ></RecommendComponent>
        )}
      </div>
    )
  }
}
